import { ButtonLoader } from "../../components/Button"

const FarmerExportScreen = ({ exportUsers, loadingExport }) => {
  return (
    <>
      <ButtonLoader
        label="Exportar Dados"
        handleClick={exportUsers}
        color="orange"
        loading={loadingExport}
        messageProcess="Exportando dados..."
      />
    </>
  )
}

export default FarmerExportScreen
